import { render } from "./GamesMastPlatforms.vue?vue&type=template&id=1b91462f"
import script from "./GamesMastPlatforms.vue?vue&type=script&lang=js"
export * from "./GamesMastPlatforms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__